export default __webpack_public_path__ + "static/media/truck.1f8f0189.png";